import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { GetInstagramFeedResponse } from '@3m5/sm_publish-frontend-api/models'

import { ApiError } from '../../store/networkContentRoot.reducer'

import { getIgPageFeed } from './instagram.actions'

export interface InstagramState {
  fetching: boolean
  instagramFeeds?: GetInstagramFeedResponse
  error: ApiError
}

const INITIAL_STATE: InstagramState = {
  fetching: false,
  error: {},
}

export const instagramReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getIgPageFeedInitiated
   */
  .case(getIgPageFeed.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getIgPageFeed
    })
  })

  .case(getIgPageFeed.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramFeeds = result
      draft.fetching = false
    })
  })

  .case(getIgPageFeed.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getIgPageFeed = (error as Response)
    })
  })
